import endpoints from "../endpoints";

export default async function getApplicationById(id) {
  let env = process.env.REACT_APP_ENV?.trim();
  return await (
    await fetch(`${endpoints.ONBOARDING.GET_APPLICATION_BY_ID[env]}?id=${id}`)
  ).json();
}
